import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container as ContainerBase } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import illustration from "images/login-illustration.svg";
import logo from "images/logo.svg";
import googleIconImageSrc from "images/google-icon.png";
import twitterIconImageSrc from "images/twitter-icon.png";
import { ReactComponent as LoginIcon } from "feather-icons/dist/icons/log-in.svg";
import { Heading } from "components/misc/Headings";
import Header, { NavLinks } from "../../components/headers/light";
import Footer from "components/footers/FiveColumnWithBackground.js";
import Hero from '../../components/hero/TwoColumnWithInput';
import Navbar from '../../components/Navbar';
import SocialIcon from "components/SocialIcon";

const Container = tw(ContainerBase)`min-h-screen bg-primary-900 text-white font-medium flex justify-center -m-8`;
const Content = tw.div`max-w-screen-xl m-0 sm:mx-20 sm:my-16 bg-white text-gray-900 shadow sm:rounded-lg flex justify-center flex-1`;
const MainContainer = tw.div`lg:w-1/2 xl:w-5/12 p-6 sm:p-12`;
const LogoLink = tw.a``;
const LogoImage = tw.img`h-12 mx-auto`;
const MainContent = tw.div`mt-12 flex flex-col items-center`;

const FormContainer = tw.div`w-full flex-1 mt-8`;

const SocialButtonsContainer = tw.div`flex flex-col items-center`;
const SocialButton = styled.a`
  ${tw`w-full max-w-xs font-semibold rounded-lg py-3 border text-gray-900 bg-gray-100 hocus:bg-gray-200 hocus:border-gray-400 flex items-center justify-center transition-all duration-300 focus:outline-none focus:shadow-outline text-sm mt-5 first:mt-0`}
  .iconContainer {
    ${tw`bg-white p-2 rounded-full`}
  }
  .icon {
    ${tw`w-4`}
  }
  .text {
    ${tw`ml-4`}
  }
`;

const DividerTextContainer = tw.div`my-12 border-b text-center relative`;
const DividerText = tw.div`leading-none px-2 inline-block text-sm text-gray-600 tracking-wide font-medium bg-white transform -translate-y-1/2 absolute inset-x-0 top-1/2 bg-transparent`;

const Form = tw.form`mx-auto max-w-xs`;
const Input = tw.input`w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5 first:mt-0`;
const SubmitButton = styled.button`
  ${tw`mt-5 tracking-wide font-semibold bg-primary-500 text-gray-100 w-full py-4 rounded-lg hover:bg-primary-900 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none`}
  .icon {
    ${tw`w-6 h-6 -ml-2`}
  }
  .text {
    ${tw`ml-3`}
  }
`;
const IllustrationContainer = tw.div`sm:rounded-r-lg flex-1 bg-purple-100 text-center hidden lg:flex justify-center`;
const IllustrationImage = styled.div`
  ${props => `background-image: url("${props.imageSrc}");`}
  ${tw`m-12 xl:m-16 w-full max-w-sm bg-contain bg-center bg-no-repeat`}
`;

export const District_Secretariat = ({
    logoLinkUrl = "#",
    illustrationImageSrc = illustration,
    headingText = "Login",
    socialButtons = [
        {
            iconImageSrc: googleIconImageSrc,
            text: "Sign In With Google",
            url: "https://google.com"
        },
        {
            iconImageSrc: twitterIconImageSrc,
            text: "Sign In With Twitter",
            url: "https://twitter.com"
        }
    ],
    submitButtonText = "Login",
    SubmitButtonIcon = LoginIcon,
    forgotPasswordUrl = "#",
    signupUrl = "#",
    roundedHeaderButton = true

}
) => {

    const secretariate = [
        {
            id: 1,
            Position: 'Chief Advisor',
            Name: 'PDG Samir Chowdhury',
            ClubName: 'RC Burdwan'
        }
    ]
    return (
        <AnimationRevealPage>
          <SocialIcon/>
            <Header roundedHeaderButton={roundedHeaderButton} />
            <Navbar />
            <ContainerBase className="m-5 text-center">
                <div className="mt-3 mb-5">
                    <Heading>District Secretariate and Administration (ROTARY YEAR 2023-24)</Heading>

                    <div className="mt-3">
                        <table width="1200" className="mx-auto">
                            <thead>
                                <tr>
                                    <td width="100">S No.</td>
                                    <td width="395">Position</td>
                                    <td width="264">Name</td>
                                    <td width="274">Club Name</td>
                                </tr>
                            </thead>
                            <tbody className="">
                            <tr><td width="82">1</td><td>District Governor</td><td>DG Kushanava Pabi</td><td>RC Burdwan</td></tr><tr><td>2</td><td>Chief Advisor</td><td>PDG Samir Chowdhury</td><td>RC Burdwan</td></tr><tr><td width="82">3</td><td>District Trainer</td><td>PDG Swapan Chowdhury</td><td>RC Asansol</td></tr><tr><td>4</td><td>Vice Governor</td><td>PDG Rintu Guha Niyogi</td><td>RC Durgapur Smart city</td></tr><tr><td width="82">5</td><td>District Secretary General</td><td>PP Nilendu Saha Sikder</td><td>RC Burdwan</td></tr><tr><td>6</td><td>District Treasurer</td><td>PP Hari Narayan Khadelwal</td><td>RC Burdwan</td></tr><tr><td width="82">7</td><td>District Secretary Publication (GML)</td><td>PP Dr. Sujit Dutta</td><td>RC Asansol</td></tr><tr><td>8</td><td>District Secretary Publication (Rotary Directory)</td><td>Rtn. Rajesh Surana</td><td>RC Burdwan</td></tr><tr><td width="82">9</td><td>District Secretary Foundation</td><td>PP Joydip Basak</td><td>RC Silk City Malda</td></tr><tr><td>10</td><td>District Secretary Administration</td><td>PP Chandrajit Kundu</td><td>RC Burdwan</td></tr><tr><td width="82">11</td><td>District Secretary Event</td><td>PP Abhishek Jitani</td><td>RC Guwahati City</td></tr><tr><td>12</td><td>District Secretary Felloship &amp; Greetings</td><td>PP Madhumita Paul</td><td>RC Greenland Silchar</td></tr><tr><td width="82">13</td><td>District Secretary Service Project&nbsp;</td><td>PP Siuli Mukherjee</td><td>RC Durgapur Smart city</td></tr><tr><td>14</td><td>District Secretary Communication</td><td>Rtn. Dr. K S Elangbam</td><td>RC Shillong</td></tr><tr><td width="82">15</td><td>District Secretary Club Co-ordination</td><td>PP Subir Roy</td><td>RC Durgapur Smart city</td></tr><tr><td width="82">16</td><td>District Secretary Information &amp; Technology</td><td>PP Rtn. Dr. Danny Dutta</td><td width="209">RC Tezpur</td></tr><tr><td>17</td><td>District Secretary Award &amp; Recognition</td><td>Rtn Chandi Charan Mondal</td><td width="209">RC Burdwan Heritage</td></tr><tr><td width="82">18</td><td>District CSR &amp; Entrepreneurship Development</td><td>PP Nikhilesh Upadhyay</td><td>RC Asansol</td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </ContainerBase>
            <Footer />
        </AnimationRevealPage>
    )
}


